import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages/insurance/InsurancePage.tsx");
